<script lang="ts">
	import { format } from 'svelte-i18n';
	import ControlCuryIntensity from './ControlCuryIntensity.svelte';
	import ControlOnOffAmbient from './ControlOnOffAmbient.svelte';
	import ControlCuryAwayMode from './ControlCuryAwayMode.svelte';
	import { navigateToCuryThirdPartyLogin } from '../../Lists/list-helpers';
	import { Alert } from '@Shelly/shelly-design-system';

	export let device, status, settings;

	const CURY_APP_PROMO_DISMISSED_KEY = 'cury_app_promo_dismissed';

	let showCuryAppPromo =
		typeof localStorage !== 'undefined' && !localStorage.getItem(CURY_APP_PROMO_DISMISSED_KEY);

	const dismissCuryAppPromo = () => {
		showCuryAppPromo = false;
		try {
			localStorage.setItem(CURY_APP_PROMO_DISMISSED_KEY, '1');
		} catch (_) {}
	};
</script>

{#if showCuryAppPromo}
	<Alert
		class="mb-s"
		type="info"
		heading={$format('cury_promo_heading', { default: 'Explore Cury app now!' })}
		message={$format('cury_promo_message', {
			default: 'Cury diffuser has its own dedicated app.',
		})}
		customIcon="fas fa-info text-primary"
		isHeadingBold
		dismissable
		on:dismissable_click={dismissCuryAppPromo}
		cta={{
			title: $format('link_go_to_cury_app', { default: 'Go to the app' }),
		}}
		on:cta_click={() => navigateToCuryThirdPartyLogin('', true)}
	/>
{/if}
<ControlOnOffAmbient {device} {status} {settings} />
<!-- ControlOnOffAmbient is a classic toggle control for the on/off state of the ambient light -->
<ControlCuryIntensity {device} {status} />
<!-- ControlCuryIntensity is a custom visualization and control for the intensity of the Cury device -->
<ControlCuryAwayMode {device} {status} />
<!-- ControlCuryAwayMode is a toggle control for the away mode -->
